import React from 'react';
import "./view/framework/StylesMain.css";
import "./view/framework/StylesToolbar.css";
import "./view/framework/StylesTheme.css";
import TopNavigation from './view/framework/nav/TopNavigation';
import MainView from './view/framework/MainView';
import themeManager from './view/framework/common/theme/themeManager';
import logo from './view/framework/logo/logo.png';


const App = () => {
  // themeManager.setTheme('dark');
  const savedTheme = localStorage.getItem('theme');
  const currentTheme = savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : 'dark';
  themeManager.setTheme(currentTheme);

  return (
    <>
      <TopNavigation />
      <head><link rel="icon" type="image/x-icon" href={logo}></link></head>
      <div className="app">
        <div className="header">
        </div>
        <MainView />
      </div>
    </>
  );
}

export default App;
